import React, { useContext } from 'react';
import { dateFormat } from '../utils';
import Lexical from "./Lexical";
import { TopicContext } from '../pages/Topic';

// mui
import { useTheme } from "@mui/material";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
//import CardActions from '@mui/material/CardActions';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
//import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

// icons
import FaceIcon from '@mui/icons-material/Face';
//import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';

// types
type TopicPaneProps = {
    children: React.ReactNode;
};

export default function TopicPane(props: TopicPaneProps) {
    const theme = useTheme();

    // topic
    const topic = useContext(TopicContext);

    return (
        <Box
            sx={{
                width: "calc(100% - 16px)",
                maxWidth: 980,
                mx: "auto",
                my: 2,
                px: 3,
                py: 2,
                backgroundColor: theme.palette.background.paper,
                borderRadius: 1,
                boxShadow: theme.shadows[1],
                boxSizing: "border-box",
            }}
        >
            <Card
                sx={{
                    borderRadius: 'unset',
                    boxShadow: 'unset',
                    overflow: 'visible',
                }}
            >
                {topic &&
                    <>
                        <Box sx={{pb:2}}>
                            <Chip
                                label={topic.topicMembers ? "限定トピック" : "公開トピック"}
                                color={topic.topicMembers ? "primary" : "default"}
                                sx={{ mr: "auto", fontSize: 12 }}
                            />
                        </Box>
                        <Box
                            sx={{
                                pb: 2,
                            }}
                        >
                            <Typography variant="h1" sx={{
                                fontSize: 20,
                                fontWeight: "bold",
                            }}>
                                {topic.title}
                            </Typography>
                        </Box>
                        <CardHeader
                            avatar={
                                <Avatar variant="rounded" aria-label="author">
                                    <FaceIcon sx={{ color: (theme) => theme.palette.grey[600], fontSize: 40 }} />
                                </Avatar>
                            }
                            title={topic.userName}
                            subheader={dateFormat(topic.postTime)}
                            sx={{
                                px: 0,
                                pt: 0,
                                pb: 2,
                                '& .MuiCardHeader-avatar': {
                                    mr: 1,
                                    '& .MuiAvatar-root': {
                                        backgroundColor: "transparent",
                                    }
                                },
                                [`& .MuiCardHeader-action`]: {
                                    alignSelf: "unset",
                                    my: 0,
                                    mr: 0,
                                },
                            }}
                        />
                    </>
                }
                <CardContent sx={{ px: 0, py: 0 }}>
                    {/* Lexical */}
                    <Lexical
                        defaultContentAsJSON={topic?.body}
                        isEditable={false}
                    />
                </CardContent>
                {/*<CardActions*/}
                {/*    sx={{*/}
                {/*        flexDirection: "row-reverse",*/}
                {/*        px: 0,*/}
                {/*        pt: 1,*/}
                {/*        pb: 0,*/}
                {/*    }}>*/}
                {/*    <IconButton*/}
                {/*        color="primary"*/}
                {/*        sx={{*/}
                {/*            px: 2,*/}
                {/*            borderRadius:  "100vh",*/}
                {/*            '&>span': {*/}
                {/*                ml: 0.5,*/}
                {/*                fontSize: 14,*/}
                {/*                color: (theme) => theme.palette.grey[600],*/}
                {/*            }*/}
                {/*        }}*/}
                {/*        aria-label="thumbup"*/}
                {/*    >*/}
                {/*        <ThumbUpAltOutlinedIcon />*/}
                {/*        <span>25</span>*/}
                {/*    </IconButton>*/}
                {/*</CardActions>*/}
            </Card>
            {props.children}
        </Box>
    );
}